/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FixedPriceProjectContractLineResource } from './';
import {
    FixedPriceProjectContractLineResourceFromJSON,
    FixedPriceProjectContractLineResourceFromJSONTyped,
    FixedPriceProjectContractLineResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FixedPriceProjectContractDetailsResource
 */
export interface FixedPriceProjectContractDetailsResource {
    /**
     * 
     * @type {Array<FixedPriceProjectContractLineResource>}
     * @memberof FixedPriceProjectContractDetailsResource
     */
    quoteLines?: Array<FixedPriceProjectContractLineResource>;
    /**
     * 
     * @type {string}
     * @memberof FixedPriceProjectContractDetailsResource
     */
    additionalNotes?: string;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceProjectContractDetailsResource
     */
    vatPercent?: number;
}

/**
 * Check if a given object implements the FixedPriceProjectContractDetailsResource interface.
 */
export function instanceOfFixedPriceProjectContractDetailsResource(value: object): value is FixedPriceProjectContractDetailsResource {
    return true;
}

export function FixedPriceProjectContractDetailsResourceFromJSON(json: any): FixedPriceProjectContractDetailsResource {
    return FixedPriceProjectContractDetailsResourceFromJSONTyped(json, false);
}

export function FixedPriceProjectContractDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceProjectContractDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteLines': json['quoteLines'] == null ? undefined : ((json['quoteLines'] as Array<any>).map(FixedPriceProjectContractLineResourceFromJSON)),
        'additionalNotes': json['additionalNotes'] == null ? undefined : json['additionalNotes'],
        'vatPercent': json['vatPercent'] == null ? undefined : json['vatPercent'],
    };
}

export function FixedPriceProjectContractDetailsResourceToJSON(value?: FixedPriceProjectContractDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'quoteLines': value['quoteLines'] == null ? undefined : ((value['quoteLines'] as Array<any>).map((v) => FixedPriceProjectContractLineResourceToJSON(v))),
        'additionalNotes': value['additionalNotes'],
        'vatPercent': value['vatPercent'],
    };
}

